import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    props: {
        link: {
            type: String,
            default: ''
        }
    }
});
